import dayjs from 'dayjs';

export const dataFormat = 'YYYY-MM-DD';
export const inputFormat = 'MM/DD/YYYY';
// pre: Date object
// post: string of 'MM/DD/YYYY'
export const defaultFormat = (date?: Date): string => {
  return dayjs(date).format(inputFormat);
};

// pre: string of format 'MM/DD/YYYY'
// post: if valid, Date object; if invalid, null
export const defaultParse = (date?: string): Date | undefined => {
  if (dayjs(date, inputFormat, true).isValid()) {
    return dayjs(date, inputFormat).toDate();
  }
  return undefined;
};
